<template lang="pug">
  .page
    section
      .text-center
        h1 CONTACT US
    section.pt-0
      b-container
        .row
          .col-md-6.text-center.pb-3
            div.p-2
              h4 Have you tried our FAQ section?
              p We've compiled a comprehensive list of answers to the most common questions asked by our collectors and artists.
              b-button.btn-outline(:to="{ name: 'help'}") VIEW FAQs
          .col-md-6
            b-card
              p LEAVE US A MESSAGE
              form.mt-3(@submit.prevent='onSubmit')
                .row
                  .col-md-6
                    b-form-group
                      label FIRST NAME
                      b-form-input(name='firstname', type='text', v-model='inputForm.firstname', required='',  autocomplete="fname", @keyup="setDisplayName()")
                  .col-md-6
                    b-form-group
                      label LAST NAME
                      b-form-input(name='lastname', type='text', v-model='inputForm.lastname', required='',  autocomplete="lname", @keyup="setDisplayName()")
                  .col-md-12
                    b-form-group
                      label EMAIL
                      b-form-input(type='email', v-model='inputForm.email', required='',  autocomplete="email")
                  .col-12
                    b-form-group
                      label MESSAGE
                      b-form-textarea(rows='3', max-rows='6' v-model='inputForm.message', required='', placeholder='How can we help?')
                button-load(type="submit", :flag="alert.busy", label="SUBMIT", classes="btn-light")
              // i.mr-2.fa.fa-mobile
              // span.text-muted 082 555 5555
            //- div.p-2
              i.mr-2.fa.fa-envelope
              span.text-muted info@wallcollective.co
            //- div.p-2
              i.mr-2.fa.fa-thumbtack.d-inline-block.align-top
              div.d-inline-block
                span.text-muted Stellenbosch, South Africa
</template>

<script>
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';

export default {
  name: 'ContactUs',
  components: {
  },
  data() {
    return {
      inputForm: {
        firstname: '',
        lastname: '',
        email: '',
        message: '',
      },
    };
  },
  mixins: [standardMix],
  computed: {
  },
  methods: {
    async onSubmit() {
      try {
        this.busy();
        await apiService.contact(this.inputForm);
        this.success('Your message was delivered');
        this.inputForm = {
          firstname: '',
          lastname: '',
          email: '',
          message: '',
        };
      } catch (error) {
        console.log({ error });
        this.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>


</style>



// WEBPACK FOOTER //
// src/components/views/Contact.vue